import PropTypes from 'prop-types';

import { Dropdown } from 'basic-components';

const Select = ({
  value,
  onChange,
  options,
  size = undefined,
  menuPortalTarget = undefined,
  ref,
  ...props
}) => (
  <Dropdown
      {...props}
      defaultValue={value !== "" ? String(value) : undefined}
      menuPortalTarget={menuPortalTarget || document.body}
      onChange={onChange}
      options={options}
      placeholder="Select"
      ref={ref}
      size={size}
  />
)

Select.displayName = "Select"


Select.propTypes = {
  menuPortalTarget: PropTypes.any, 
  onChange: PropTypes.func.isRequired, 
  options: PropTypes.any.isRequired, 
  size: PropTypes.string, 
  value: PropTypes.any.isRequired,
}

export default Select;